import $http from "./http";
import config from "./config";

export default {
  name: "flightpolicy",
  getUrl(url) {
    return config.getUrl(this.name, url);
  },
  GDSRT(pnr, applyarea) {
    return $http.get(this.getUrl(`/PolicyInfo/GDSRT?pnr=${pnr}&applyarea=${applyarea}`));
  },

  searchndcProduct(data) {
    return $http.post(this.getUrl(`/PolicyInfo/SearchNdcProduct`), data, {
      failTips: false,
    });
  },

  getLevelInfoList(data) {
    return $http.post(this.getUrl("/LevelInfo/List"), data);
  },
  getLevelInfo(id) {
    return $http.get(this.getUrl("/LevelInfo/Details/" + id));
  },
  saveLevelInfo(data) {
    return $http.post(this.getUrl("/LevelInfo/Save"), data);
  },
  getCustomerLevelList(data) {
    return $http.post(this.getUrl("/CustomerLevel/List"), data);
  },
  delCustomerLevel(data) {
    return $http.post(this.getUrl("/CustomerLevel/Delete"), data);
  },
  //此接口已废除
  FlightSearch(data) {
    return $http.post(this.getUrl(`/FlightSearch/Search`), data);
  },
  searchPolicyRate(id, data) {
    return $http.post(this.getUrl(`/AmendPolicy/CalcPrice/${id}`), data);
  },
  // SaveFlight(data) {
  //     return $http.post(this.getUrl(`/FlightSearch/SaveFlight`), data);
  // },
  getPolicyInfoList(data) {
    return $http.post(this.getUrl(`/PolicyInfo/List`), data);
  },
  PolicyInfoDetails(id) {
    return $http.get(this.getUrl(`/PolicyInfo/Details/${id}`));
  },
  savePolicyInfo(data) {
    return $http.post(this.getUrl(`/PolicyInfo/Update`), data);
  },
  getExtraInfoList(data) {
    return $http.post(this.getUrl("/ExtraInfo/List"), data);
  },

  UpdatePolicyInfoState(data) {
    return $http.post(this.getUrl(`/PolicyInfo/UpdatePolicyState`), data);
  },
  deletePolicyInfo(policyId) {
    return $http.post(this.getUrl(`/PolicyInfo/delete?id=${policyId}`), {});
  },
  SaveBatch(data) {
    return $http.post(this.getUrl(`/PolicyInfo/SaveBatch`), data);
  },
  CopyPolicyInfo(id) {
    return $http.get(this.getUrl(`/PolicyInfo/CopyFlightPolicy/${id}`));
  },
  getFileContent(data) {
    return $http.post(this.getUrl(`/AmendPolicy/Uploadfile`), data, {
      failTips: false,
    });
  },

  deleteFlightPolicy(id) {
    return $http.get(this.getUrl(`/PolicyInfo/Delete?id=${id}`));
  },

  // searchAllEtdz(applyarea) {
  //     return $http.get(this.getUrl(`/Policy/SearchAllEtdz?applyArea=${applyarea}`));
  // },
  getsetting(id) {
    return $http.get(this.getUrl(`/TradeSetting/GetAllSet/${id}`));
  },
  savetradeset(data) {
    return $http.post(this.getUrl("/TradeSetting/Add"), data);
  },
  changetimelist(data) {
    return $http.post(this.getUrl("/AmendTime/List"), data);
  },
  Changetimedelete(id) {
    return $http.get(this.getUrl(`/AmendTime/Delete/${id}`));
  },
  changetimeDetail(id) {
    return $http.get(this.getUrl(`/AmendTime/ChangeTimeDetails/${id}`));
  },
  changetimeupdate(data) {
    return $http.post(this.getUrl("/AmendTime/ChangeTimeUpdate"), data);
  },
  RulsList(data) {
    return $http.post(this.getUrl("/AmendPolicy/List"), data);
  },
  rulesDetail(id) {
    return $http.get(this.getUrl(`/AmendPolicy/RulesDetails/${id}`));
  },
  rulesupdate(data) {
    return $http.post(this.getUrl("/AmendPolicy/RulesUpdate"), data);
  },
  RuelsDisable(id) {
    return $http.get(this.getUrl(`/AmendPolicy/RuelsDisable/${id}`));
  },
  classruleslist(data) {
    return $http.post(this.getUrl("/AmendRate/List"), data);
  },
  classrulesdeatel(data) {
    return $http.post(this.getUrl("/AmendRate/ClassRulesDetails"), data);
  },
  classrulesdelete(data) {
    return $http.post(this.getUrl("/AmendRate/Delete"), data);
  },
  classrulesupdate(data) {
    return $http.post(this.getUrl("/AmendRate/ClassRulesUpdate"), data);
  },
  customerLevel() {
    return $http.get(this.getUrl("Policy/customerLevel"));
  },
  Uploadfile(data, id) {
    return $http.post(this.getUrl(`/AmendPolicy/Uploadfile/${id}`), data);
  },
  BathUploadfile(data, id, AmendID) {
    return $http.post(this.getUrl(`/AmendRate/BathUploadfile?id=${id}&AmendID=${AmendID}`), data);
  },
  CreatePolicy(data) {
    return $http.post(this.getUrl("/FlightPolicy/CreatePolicy"), data);
  },
  ProductInfo(data) {
    return $http.post(this.getUrl("/FlightPolicy/ProductInfo"), data);
  },
  PriceVerify(data) {
    return $http.post(this.getUrl("/FlightPolicy/PriceVerify"), data);
  },
  // ServiceFee(data){
  //     return $http.post(this.getUrl('/FlightPolicy/ServiceFee'),data);
  // },
  // SearchSupplyPolicy(data) {
  //     return $http.post(this.getUrl('/FlightPolicy/SearchSupplyPolicy'), data);
  // },

  //大客户名单
  ClientUserList(data) {
    return $http.post(this.getUrl("/ClientUser/list"), data);
  },
  ClientUserSave(data) {
    return $http.post(this.getUrl("/ClientUser/ClientUserSave"), data);
  },
  ClientUserDetails(id) {
    return $http.get(this.getUrl(`/ClientUser/Details/${id}`));
  },
  ClientUserDelete(id) {
    return $http.get(this.getUrl(`/ClientUser/Delete/${id}`));
  },
  ClientUserUploadfile(data) {
    return $http.post(this.getUrl(`/ClientUser/Uploadfile`), data);
  },
  // 大客户协议
  ClientCodeList(data) {
    return $http.post(this.getUrl("/ClientCode/list"), data);
  },
  ClientCodeDetails(id) {
    return $http.get(this.getUrl(`/ClientCode/Details/${id}`));
  },
  ClientCodeSave(data) {
    return $http.post(this.getUrl("/ClientCode/Save"), data);
  },
  ClientCodeDelete(id) {
    return $http.get(this.getUrl(`/ClientCode/Delete/${id}`));
  },

  getSalesRuleList(data) {
    return $http.post(this.getUrl("/SalesRule/List"), data);
  },
  getSalesRuleDetails(id) {
    return $http.get(this.getUrl(`/SalesRule/Details/${id}`));
  },
  saveSalesRule(data) {
    return $http.post(this.getUrl("/SalesRule/Save"), data);
  },
  deleteSalesRule(id) {
    return $http.post(this.getUrl(`/SalesRule/Delete/${id}`));
  },
  SearchAmendPolicy(id, applyarea) {
    return $http.get(this.getUrl(`/Product/RuleInfo?id=${id}&ApplyArea=${applyarea}`), {
      failTips: false,
    });
  },
  getProductList(data,failTips) {
    return $http.post(this.getUrl("/product/list"), data, {
      failTips,
    });
  },
  SearchProductList(data) {
    return $http.post(this.getUrl("/product/SearchProductList"), data);
  },
  SearchItineraryList(data) {
    return $http.post(this.getUrl("/product/SearchItineraryList"), data);
  },
  getProductGoods(data) {
    return $http.post(this.getUrl(`/product/GetGoods`), data);
  },
  GetChangeOrderPrice(data) {
    return $http.post(this.getUrl("/amendpolicy/GetChangeOrderPrice"), data);
  },
  getRobotInfo(id) {
    return $http.get(this.getUrl("/robotinfo/details?id=" + id));
  },
  getRobotList(data) {
    return $http.post(this.getUrl("/robotinfo/list"), data);
  },
  saveRobotInfo(data) {
    return $http.post(this.getUrl("/robotinfo/save"), data);
  },
  deleteRobotInfo(id) {
    return $http.get(this.getUrl("/robotinfo/delete?id=" + id));
  },
  getBerthList(data) {
    return $http.post(this.getUrl("/StandardBerthInfo/list"), data);
  },
  updateBerthInfo(data) {
    return $http.post(this.getUrl("/StandardBerthInfo/updateBerthInfo"), data);
  },
  getCompanyUnionList(data) {
    return $http.post(this.getUrl("/CompanyUnion/list"), data);
  },
  saveCompanyUnion(data) {
    return $http.post(this.getUrl("/CompanyUnion/Save"), data);
  },
  delCompanyUnion(id) {
    return $http.get(this.getUrl("/CompanyUnion/delete?id=" + id));
  },
  getRulepolicylist(data) {
    return $http.post(this.getUrl("/RulesPolicy/list"), data);
  },
  delrulepolicy(id) {
    return $http.get(this.getUrl("/rulespolicy/delete?id=" + id));
  },
  saverulepolicy(data) {
    return $http.post(this.getUrl("/rulespolicy/save"), data);
  },
  runrule(data) {
    return $http.post(this.getUrl("/rulespolicy/RunRule"), data);
  },
  SaveTime(data) {
    return $http.post(this.getUrl("/StandardBerthInfo/SaveTime"), data);
  },
  getSaveModel() {
    return $http.get(this.getUrl("/StandardBerthInfo/SearchSaveModel"));
  },
  runberth() {
    return $http.get(this.getUrl("/Service/RunStandardBerth"));
  },
  ErrorRunAgain() {
    return $http.get(this.getUrl("/StandardBerthInfo/ErrorRunAgain"));
  },
  getBaggagelist(data) {
    return $http.post(this.getUrl("/BaggageRule/list"), data);
  },
  saveBaggage(data) {
    return $http.post(this.getUrl("/BaggageRule/save"), data);
  },
  getBaggage(id) {
    return $http.get(this.getUrl("/BaggageRule/Details/" + id));
  },
  searchbagbyproduct(id, applyarea) {
    return $http.get(this.getUrl(`/Product/baggage?id=${id}&ApplyArea=${applyarea}`), {
      failTips: false,
    });
  },
  getBagFileContent(data) {
    return $http.post(this.getUrl(`/BaggageRule/Uploadfile`), data, {
      failTips: false,
    });
  },
  bagdel(data) {
    return $http.post(this.getUrl("/baggagerule/delete"), data);
  },
  getNotifylist(data) {
    return $http.post(this.getUrl("/NotifyRule/list"), data);
  },
  saveNotify(data) {
    return $http.post(this.getUrl("/NotifyRule/save"), data);
  },
  getNotify(id) {
    return $http.get(this.getUrl("/NotifyRule/Details/" + id));
  },
  delNotify(data) {
    return $http.post(this.getUrl("/notifyrule/delete"), data);
  },
  getndcamendprice(id) {
    return $http.get(this.getUrl("/amendpolicy/GetOrderAmendPrice?id=" + id), {
      failTips: false,
    });
  },
};



// WEBPACK FOOTER //
// ./src/apis/flightPolicyApi.js